'use strict';

import './ArticlesItem.css';
import React, { useMemo } from 'react';
import { lang } from '../../../../common/baseData';

function ArticlesItem(props) {
  const maxLength = 170;
  const langPrefix = lang === 'ru' ? '' : `/${lang}`;

  const truncatedText = useMemo(() => {
    // Удаляем HTML-теги
    const plainText = props.DETAIL_TEXT.replace(/<[^>]*>/g, '');

    // Ограничиваем длину текста
    return plainText.length > maxLength
        ? plainText.slice(0, maxLength) + '...'
        : plainText;
  }, [props.DETAIL_TEXT, maxLength]);

  return (
      <div className="item">
        <div className="img">
          <a href={`${props.DETAIL_PAGE_URL}`}>
            <img
                data-src={props.PREVIEW_PICTURE}
                src={props.PREVIEW_PICTURE}
                alt={props.NAME}
                title={props.NAME}
                className=" ls-is-cached lazyloaded"
            />
          </a>
        </div>
        <div className="item-description">
          <div className="info-row">
            <a href={`${langPrefix}/news/rubric_${props.PROPERTY_RUBRIC_LINK}/`}>
              {props.PROPERTY_RUBRIC_NAME}
            </a>
            <span className="date">{props.DATE_CREATE}</span>
            <div className="counter">
              <i className="icon" />
              <span>{props.SHOW_COUNTER}</span>
            </div>
          </div>
          <div className="item-name">
            <a href={`${props.DETAIL_PAGE_URL}`}>
              {props.NAME}
            </a>
          </div>
          <div className="item-text">
            {truncatedText}
            <a href={`${props.DETAIL_PAGE_URL}`}>
              {props.messages.NLCCN_MORE_DETAIL_BUTTON}
            </a>
          </div>
        </div>
      </div>
  );
}

export default ArticlesItem;